"use client";

import { createContext, useRef } from "react";
import PropTypes from "prop-types";

const SectionContext = createContext();

const SectionContextProvider = ({ children }) => {
  const parallaxScrollerRef = useRef();

  const contextValue = {
    parallaxScrollerRef,
  };

  return (
    <SectionContext.Provider value={contextValue}>
      {children}
    </SectionContext.Provider>
  );
};

SectionContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

export { SectionContextProvider, SectionContext };
